"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.primitives = void 0;
const fontWeight = {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
};
/**
 * This function takes numerical font size and line height values and calculates
 * the line height as a percentage of the font size. This way, it's easy to keep
 * this file in sync with the design guide, but also easy to use the values in
 * CSS.
 *
 * @param fontSize The font size in pixels
 * @param lineHeightInPx The line height in pixels
 */
const defineFontSize = (fontSize, lineHeightInPx) => {
    return {
        fontSize,
        lineHeight: lineHeightInPx / fontSize,
    };
};
const fontSize = {
    "3xl": defineFontSize(30, 36),
    "2xl": defineFontSize(24, 32),
    xl: defineFontSize(20, 28),
    lg: defineFontSize(18, 28),
    md: defineFontSize(16, 24),
    sm: defineFontSize(14, 20),
    xs: defineFontSize(12, 16),
};
exports.primitives = {
    fontSize,
    fontWeight,
};
//# sourceMappingURL=primitives.js.map